module.exports = __webpack_public_path__ + "img/selectDownF38235.55a68978.svg";